// no dangerouslySetInnerHTML — titles are user-controlled text (SEC-REQ-4)
//
// V2 source path: customer/midas/components/v2/history/MidasHistorySkeletonV2.tsx
// V1 source: none (greenfield — Phase 4)
// Strategy: scratch
// Verified no-MUI: yes
// Phase: 4
//
// Loading skeleton for the history page list. Shows 8 shimmer rows grouped
// under one date eyebrow placeholder so the user gets a sense of the layout
// before data arrives. Reuses the warm-stone palette so the shimmer doesn't
// stand out against the bone background.
import React from "react";

const MidasHistorySkeletonV2: React.FC = () => (
  <div
    role="status"
    aria-label="Loading conversations"
    className="flex flex-col gap-3 px-1 pt-3"
  >
    <div
      className="h-3 w-20 animate-pulse rounded bg-midas-warm-stone"
      aria-hidden="true"
    />
    {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
      <div
        key={i}
        className="flex min-h-[64px] items-start gap-3 rounded-lg border border-[rgba(44,38,32,0.06)] bg-white px-4 py-3"
        aria-hidden="true"
      >
        <div className="flex w-[56px] flex-shrink-0 flex-col gap-1.5">
          <div className="h-2.5 w-12 animate-pulse rounded bg-midas-warm-stone" />
          <div className="h-2 w-10 animate-pulse rounded bg-midas-warm-stone/70" />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-1.5">
          <div className="h-2.5 w-16 animate-pulse rounded bg-midas-warm-stone/70" />
          <div className="h-3 w-3/4 animate-pulse rounded bg-midas-warm-stone" />
        </div>
        <div
          className="h-2.5 w-20 flex-shrink-0 animate-pulse rounded bg-midas-warm-stone/70"
        />
      </div>
    ))}
  </div>
);

export default MidasHistorySkeletonV2;
